module.exports = __webpack_public_path__ + "static/media/stofferingen-45.727fa8ca.jpg";